"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _Button = _interopRequireDefault(require("../../../../Button")),
    _Link = _interopRequireDefault(require("../../../../Link")),
    _Dropdown = _interopRequireDefault(require("../../../../Dropdown")),
    _filtersMobile = require("../styles/filtersMobile"),
    _Text = _interopRequireDefault(require("../../../../Text"));

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var FiltersMobile = function (a) {
  function b() {
    var a;
    return (0, _classCallCheck2["default"])(this, b), a = c.call(this), a.onVisibilityChanged = function () {
      a.setState({
        animationInProgress: !0
      }), setTimeout(function () {
        a.setState({
          animationInProgress: !1
        });
      }, _filtersMobile.OPEN_ANIMATION_DURATION_MS);
    }, a.onSelectFilter = (0, _lodash["default"])(function (b) {
      return function (c) {
        var d = c || {
          label: {
            props: null
          },
          value: null
        },
            e = d.label.props,
            f = d.value;
        a.setState(function (a) {
          var c = a.filterValues;
          return {
            filterValues: _objectSpread(_objectSpread({}, c), {}, (0, _defineProperty2["default"])({}, b, _objectSpread(_objectSpread({}, e), {}, {
              value: f
            })))
          };
        });
      };
    }), a.onResetFilters = function () {
      var b = a.props.resetFilters;
      a.setState({
        filterValues: {}
      }), b();
    }, a.applyFilters = function () {
      var b = a.props,
          c = b.setSelectedFilters,
          d = b.toggleVisibility,
          e = a.state.filterValues;
      c(e), d();
    }, a.state = {
      filterValues: {},
      animationInProgress: !1
    }, a;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(a) {
      var b = a.visible,
          c = this.props.visible;
      c !== b && this.onVisibilityChanged();
    }
  }, {
    key: "render",
    value: function render() {
      var a = this,
          b = this.props,
          c = b.filters,
          d = b.selectedFilters,
          e = b.visible,
          f = this.state,
          g = f.filterValues,
          h = f.animationInProgress;
      return _react["default"].createElement("div", {
        className: (0, _filtersMobile.MOBILE_FILTERS_CONTAINER)(e, h)
      }, _react["default"].createElement("div", {
        className: _filtersMobile.MOBILE_FILTERS
      }, _react["default"].createElement(_Text["default"], {
        heading4: !0
      }, "Sort & Filter"), Object.keys(c).map(function (b) {
        return Array.isArray(c[b]) ? _react["default"].createElement(_Dropdown["default"], {
          key: b,
          id: "all-filter-dropdown",
          className: _filtersMobile.DROPDOWN_CLS_MOBILE,
          options: c[b],
          defaultValue: d[b] || g[b] || c[b][0],
          onChange: a.onSelectFilter(b),
          type: "BUTTON"
        }) : _react["default"].createElement(_Dropdown["default"], (0, _extends2["default"])({
          key: b,
          id: "all-filter-dropdown",
          className: _filtersMobile.DROPDOWN_CLS_MOBILE,
          options: c[b].options || [],
          onChange: a.onSelectFilter(b),
          type: "BUTTON"
        }, c[b]));
      }), _react["default"].createElement("div", {
        className: _filtersMobile.MODAL_BUTTONS
      }, _react["default"].createElement(_Button["default"], {
        onClick: this.onResetFilters,
        className: _filtersMobile.RESET_BUTTON,
        type: "TERTIARY"
      }, "Reset Filters"), _react["default"].createElement(_Button["default"], {
        onClick: this.applyFilters,
        type: "SECONDARY"
      }, "Apply Filters"))), _react["default"].createElement("hr", null));
    }
  }]), b;
}(_react.Component),
    _default = FiltersMobile;

exports["default"] = _default;